import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    updateEmail,
    GithubAuthProvider,
} from 'firebase/auth';
import {toast} from 'react-toastify';
import 'firebase/compat/firestore';

import {getFirestore, query, getDocs, collection, where, addDoc} from 'firebase/firestore';
import {initializeApp} from 'firebase/app';
import axios from "axios";

const app = initializeApp(JSON.parse(process.env.REACT_APP_FIREBASECONFIG));
const auth = getAuth(app);
const db = getFirestore(app)

const googleProvider = new GoogleAuthProvider()
const githubAuthProvider = new GithubAuthProvider()

const signInWithGoogle = async (navigate) => {
    try {
        const res = await signInWithPopup(auth, googleProvider);
        if (res.user.uid) {
            toast.success(`Benvenuto!`, {theme: 'colored'});
            const user = await axios.post(
                process.env.REACT_APP_STRAPI_URL + 'e-commerce-users',
                {
                    data: {
                        email: res.user.email,
                        firebaseId: res.user.uid,
                    },
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + process.env.REACT_APP_STRAPI_TOKEN
                    },
                }
            );
            if (user.status === 200) {
                navigate('/account')
            } else throw new Error('Errore!');
        }
    } catch (error) {
        console.log('Errore : ', error)
    }
}

const signInWithGitHub = async () => {
    try {
        const res = await signInWithPopup(auth, githubAuthProvider);
        const user = res.user;
        const q = query(collection(db, 'users'), where('uid', '==', user.uid));
        const docs = await getDocs(q);

        if (docs.docs.length === 0) {
            await addDoc(collection(db, 'users'), {
                uid: user.uid,
                name: user.displayName,
                authProvider: 'github',
                email: user.email
            })
        }
    } catch (error) {
        console.log('Errore : ', error)
    }
}

const loginInWithEmailAndPassword = async (email, password, navigate) => {
    try {
        const res = await signInWithEmailAndPassword(auth, email, password);
        if (res.user.uid) {
            toast.success(`Benvenuto!`, {theme: 'colored'});
            navigate('/account')
        }
    } catch (error) {
        toast.error(`Le credenziali da lei inserite non sono valide!`, {theme: 'colored'});
        console.log('Errore : ', error)
    }
}

const registerWithEmailAndPassword = async (email, password, navigate) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);

        if (res.user.uid) {
            toast.success(`Benvenuto!`, {theme: 'colored'});
            const user = await axios.post(
                process.env.REACT_APP_STRAPI_URL + 'e-commerce-users',
                {
                    data: {
                        email: res.user.email,
                        firebaseId: res.user.uid,
                    },
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + process.env.REACT_APP_STRAPI_TOKEN
                    },
                }
            );
            if (user.status === 200) {
                navigate('/account')
            } else throw new Error('Errore!');
        }

    } catch (error) {
        toast.error(`Si è verificato un errore!`, {theme: 'colored'});
        console.log('Errore : ', error)
    }
}

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
    } catch (error) {
        console.log('Errore : ', error)
    }
}

const updateFEmail = async (newEmail) => {
    try {
        await updateEmail(auth.currentUser, newEmail)
        console.log('Email cambiata con successo.');
    } catch (error) {
        toast.error(`Si è verificato un errore : ${error}`, {theme: 'colored'});
        console.log('Errore durante il cambio dell\'email:', error);
    }
};

const logout = async () => {
    await signOut(auth);
}

export {
    auth,
    db,
    signInWithGoogle,
    signInWithGitHub,
    loginInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
    updateFEmail
}
